const sourcesOf = (row: any) => [row, row?.meta, row?.qa, row?.hierarchy, row?.sr, row?._source];

const readCoord = (row: any, key: string) => {
    for (const source of sourcesOf(row)) {
        const parsed = parseFloat(source?.[key]);
        if (Number.isFinite(parsed)) return parsed;
    }
    return null;
};

export const surveyMapPoints = (rows: any[] = []) =>
    rows.map((row) => ({
        ...row,
        lat: readCoord(row, "lat"),
        long: readCoord(row, "long"),
    }));
